import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@americanexpress/dls-react';

const HotelCheckInOut = ({ checkInText, checkOutText, details }) => (
  <div className="row margin-4-t">
    <div className="col-xs-12 col-md-6">
      <Heading level={3} variant="sans-medium-bold" className="margin-1-b">
        Check-In
      </Heading>
      <p className="body margin-b-md-down">
        {checkInText || 'N/A'}
      </p>
    </div>
    <div className="col-xs-12 col-md-6">
      <Heading level={3} variant="sans-medium-bold" className="margin-1-b">
        Check-Out
      </Heading>
      <p className="body margin-b-md-down">
        {checkOutText || 'N/A'}
      </p>
    </div>
    {details ? (
      <div className="col-12 margin-2-t">
        <div
          className="body"
          // eslint-disable-next-line react/no-danger -- content is sourced from trusted internal API
          dangerouslySetInnerHTML={{ __html: details }}
        />
      </div>
    ) : null}
  </div>
);

HotelCheckInOut.propTypes = {
  checkInText: PropTypes.string,
  checkOutText: PropTypes.string,
  details: PropTypes.string,
};

export default HotelCheckInOut;
